module.exports = __webpack_public_path__ + "media/media/cases/rosneft/_vyacheslav-673f9394aa8c12380d7a5e128707c65f.jpg";